import React from "react";
import { usePageMeta } from "@/components/site/usePageMeta";
import { PageHero } from "@/components/site/PageHero";
import { AboutSection } from "@/components/site/AboutSection";
import { WhySection } from "@/components/site/WhySection";
import { Testimonials } from "@/components/site/Testimonials";
import { ContactSection } from "@/components/site/ContactSection";
import { ROUTES } from "@/components/site/data";

const IMG = "https://images.unsplash.com/photo-1526948531399-320e7e40f0ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export default function AboutPage() {
  usePageMeta(
    "About | Wallstreet Realty",
    "Wallstreet Realty is a Southern California real estate and mortgage brokerage led by John Pagani, a licensed broker with over 25 years of experience."
  );
  return (
    <>
      <PageHero
        crumb="About"
        eyebrow="A Legacy Built on Trust"
        title="A Modern Brokerage With Local Roots"
        subtitle="Led by John Pagani, a licensed real estate and mortgage broker with over 25 years of experience serving Southern California."
        image={IMG}
        ctas={[
          { label: "Search Homes", href: ROUTES.search, testid: "about-hero-search" },
          { label: "Get My Home Value", href: ROUTES.sell, variant: "outline", testid: "about-hero-value" },
        ]}
      />
      <AboutSection />
      <WhySection />
      <Testimonials />
      <ContactSection />
    </>
  );
}
